<template>
    <div class="listWrapper">
        <div class="listHeader">
            <div class="listHeaderLeft">
                <span class="roundedIcon pointer" v-if="isExpanded" @click="isExpanded = false;" :key="`expanded_${list.id}`"
                    ><i class="fas fa-arrow-down"
                /></span>
                <span class="roundedIcon pointer" v-else @click="isExpanded = true;" :key="`collapsed_${list.id}`">
                    <i class="fas fa-arrow-right"></i>
                </span>
                <template v-if="isBeingEdited">
                    <input v-model="isBeingEditedName" />
                    <span class="roundedIcon pointer" @click="modifyNotificationList"><i class="fas fa-check-circle"/></span>
                    <span class="roundedIcon pointer" @click="isBeingEdited = !isBeingEdited;"> <i class="fas fa-minus-circle"/></span>
                </template>
                <template v-else>
                    {{ $t("notificationList.list") }}&nbsp;{{ list.name }}
                </template>
            </div>
            <div class="listHeaderRight">
                {{ list.users.length }} {{ $t("notificationList.recipients") }}
                <span
                    class="roundedIcon pointer"
                    @click="
                        isBeingEdited = !isBeingEdited;
                        isBeingEditedName = list.name;
                    "
                    :key="`non_edit_${list.id}`"
                >
                    <i class="fas fa-pencil-alt"
                /></span>
                <span class="roundedIcon pointer" @click="deleteNotificationList(list);" :key="`non_edit_${list.id}`">
                    <i class="fas fa-trash"
                /></span>
            </div>
        </div>
        <div v-show="isExpanded">
            <div style="margin-top: 15px">
                <SelectBloc
                    :value="list.application.id"
                    @change="updateApplication(parseInt($event));"
                    :required="true"
                    :options="applications"
                    :label="'Application'"
                />
            </div>
            <div>
                <CheckboxGroupBloc
                    :name="'zone'"
                    :label="'Zones'"
                    :options="zonesForSelect"
                    :value="selectedZonesForCheckboxes"
                    :have-logo="false"
                    @input="updateZones"
                ></CheckboxGroupBloc>
            </div>
            <div class="listHeader">
                <div>
                    <input type="radio" id="all" :value="false" v-model="isFiltered" />
                    <label for="all">{{ $t("notificationList.allUsers") }}</label>
                    <input type="radio" id="filtered" :value="true" v-model="isFiltered" />
                    <label for="filtered">{{ $t("notificationList.selectedRecipients") }}</label>
                    <span v-if="list.id !== undefined" class="roundedIcon pointer" @click="isTooltipVisible = !isTooltipVisible;">
                        <i class="fas fa-info"></i
                    ></span>
                </div>
                <ul class="tooltip" v-if="isTooltipVisible">
                    <li>distribution list id {{ list.id }}</li>
                    <li>created by {{ list.createdBy.lastname }}, {{ list.createdBy.firstname }} ({{ list.createdAt }})</li>
                    <li>modified by {{ list.modifiedBy.lastname }}, {{ list.modifiedBy.firstname }} ({{ list.modifiedDate }})</li>
                </ul>
            </div>
            <table class="table">
                <tbody>
                    <tr v-for="user in filteredUsers" v-bind:key="`${list.id}_${user.id}`">
                        <td>
                            <span style="text-transform: uppercase">{{ user.lastname }}</span
                            >, <span style="text-transform: capitalize">{{ user.firstname }}</span>
                        </td>
                        <td><input @click="handleUser(user, list);" :checked="isUserOnList(user)" type="checkbox" /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import TryLoad from "@/mixins/TryLoadMixin";
import { EventBus, EVENTS } from "./EventBus";
import CheckboxGroupBloc from "@/components/ui/Form/CheckboxGroupBloc";
import SelectBloc from "@/components/ui/Form/SelectBloc";

export default {
    components: { SelectBloc, CheckboxGroupBloc },
    props: {
        list: Object,
        users: Array,
        brand: Object,
        zones: Array,
        applications: Array
    },
    mixins: [TryLoad],
    data() {
        return {
            isExpanded: false,
            isFiltered: true,
            isBeingEdited: false,
            isBeingEditedName: "",
            isTooltipVisible: false
        };
    },
    computed: {
        filteredUsers() {
            let users = this.isFiltered ? this.list.users : this.users;
            return users.sort((u1, u2) => {
                return u1.lastname.toLowerCase() > u2.lastname.toLowerCase() ? 1 : -1;
            });
        },
        zonesForSelect() {
            return this.zones.map(zone => {
                return { value: zone.id, label: zone.name };
            });
        },
        selectedZonesForCheckboxes() {
            return this.list.zones.map(zone => {
                return zone.id;
            });
        }
    },
    methods: {
        handleUser(user) {
            if (this.isUserOnList(user)) {
                this.removeUser(user);
            } else {
                this.addUser(user);
            }
        },
        updateNotificationList(notificationList) {
            EventBus.$emit(EVENTS.UPDATE_NOTIFICATION_LIST, notificationList);
        },
        addUser(user) {
            let updatedList = this.list;
            updatedList.users.push(user);
            this.updateNotificationList(updatedList);
        },
        removeUser(user) {
            let updatedList = this.list;
            updatedList.users = this.list.users.filter(currentUser => currentUser.id !== user.id);
            this.updateNotificationList(updatedList);
        },
        modifyNotificationList() {
            let updatedList = { ...this.list, ...{ name: this.isBeingEditedName } };
            this.updateNotificationList(updatedList);
            this.isBeingEdited = false;
        },
        async deleteNotificationList() {
            EventBus.$emit(EVENTS.DELETE_NOTIFICATION_LIST, this.list);
        },
        isUserOnList(user) {
            return this.list.users.some(innerUser => {
                return user.id === innerUser.id;
            });
        },
        updateZones(zones) {
            this.list.zones = this.zones.filter(zone => zones.includes(zone.id));
            this.updateNotificationList(this.list);
        },
        updateApplication(applicationId) {
            this.list.application.id = applicationId;
            this.updateNotificationList(this.list);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/themes";
@import "../../../assets/css/media";
.listWrapper {
    padding-bottom: 20px;
}
.roundedIcon {
    width: 30px;
    height: 30px;
    line-height: 34px;
}
ul {
    list-style: none;
}
table tr.striped {
    background-color: rgba(0, 0, 0, 0.05);
}
.listHeader {
    display: flex;
    background-color: grey;
    padding: 5px;
    margin-top: 3px;
}
.listHeaderLeft {
    width: 70%;
}
.listHeaderRight {
    width: 30%;
}
@include sm {
    .listHeaderLeft {
        width: 100%;
        display: block;
    }
    .listHeaderRight {
        width: 100%;
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// NotificationListDetail.vue?1fbdd088